import React, { Component } from "react";
import defaultWoman from "../../images/defaultWoman.png";
import "./ProfilCar.css";
import AddCommand from "../Commands/AddCommand/AddCommand";
import DotCommand from "../Commands/DotCommand/DotCommand";
import ExpandCommand from "../Commands/ExpandCommand/ExpandCommand";
import CloseCommand from "../Commands/CloseCommand/CloseCommand";
import CollapseCommand from "../Commands/CollapseCommand/CollapseCommand";
import ReduceCommand from "../Commands/ReduceCommand/ReduceCommand";

class ProfilCar extends Component {
  state = {
    menuItems: [
      {
        id: "0",
        icone: "",
        item: "Ajouter",
        value: "",
        addSep: false,
        sep: "0",
      },
      {
        id: "1",
        icone: "",
        item: "Modifier",
        value: "",
        isNested: "",
        addSep: false,
      },
      {
        id: "2",
        icone: "",
        item: "Supprimer",
        value: "",
        isNested: "",
        addSep: true,
      },
    ],
  };
  render() {
    return (
      <div>
        <div className="profil">
          <div className="firstRow">
            <div className="left">
              <div>
                <span>Anselme</span>
              </div>
              <div>
                <span>CEO</span>
              </div>
            </div>
            <div className="right">
              <img
                height="100%"
                width="100%"
                src={defaultWoman}
                alt="logo"
              ></img>
            </div>
          </div>
          <div className="secondRow">
            <CollapseCommand isVisible={true} />
            <ReduceCommand />
            <AddCommand
              detailForm={<div style={{ position: "absolute" }}>CEO</div>}
            />
            <DotCommand menuItems={this.state.menuItems} />
          </div>
        </div>
      </div>
    );
  }
}

export default ProfilCar;
